import React from "react";
import WebsiteFooter from "../Footer/WebsiteLoader";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { Logo } from "./../../Public/assets/index";
import { useTheme } from "../../Context/Theme";

const WebsiteLayout = ({ children }) => {
  const navigate = useNavigate();
  const { getThemeLogo, isShowPartnershipLogo } = useTheme();
  const dynamicLogo = getThemeLogo();
  const [logoLoaded, setLogoLoaded] = React.useState(false);

  return (
    // !max-w-[1520px]
    <div className=" mx-auto !w-full flex flex-col flex-grow overflow-hidden">
      {/* !max-w-[1520px] */}
      <nav className="!w-full  bg-white shadow-sm fixed top-0 z-50">
        <div className="h-[63px] lg:h-[80px] px-6 xl:px-[134px] flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img
              src={Logo}
              alt=""
              className={`!w-[75px] md:!w-[135px] lg:w-auto hover:cursor-pointer hover:pointer-events-auto ${logoLoaded ? "" : "invisible"}`}
              onLoad={() => setLogoLoaded(true)}
            />
          </div>

          <Button
            className="w-auto hover:cursor-pointer px-[12px] md:px-[36px] text-[12px] md:text-[18px] md:leading-[27px]  font-[500] font-geomanistMedium bg-blueish  hover:pointer-events-auto"
            onClick={() => {
              navigate("/email");
            }}
          >
            Login
          </Button>
        </div>
      </nav>
      {children}

      {/* In partnership with section */}
      {dynamicLogo && isShowPartnershipLogo && (
        <div className="flex items-end justify-center w-full gap-3 pb-8 mt-8">
          <p className="text-[14px] md:text-[16px] font-geomanistRegular text-greyish">
            In partnership with
          </p>
          <img src={dynamicLogo} alt="Partner Logo" className="h-[35px]" />
        </div>
      )}

      <WebsiteFooter />
    </div>
  );
};

export default WebsiteLayout;
